import { render } from "./AdminDashboard.vue?vue&type=template&id=16ea0074&scoped=true"
import script from "./AdminDashboard.vue?vue&type=script&lang=js"
export * from "./AdminDashboard.vue?vue&type=script&lang=js"

import "./AdminDashboard.vue?vue&type=style&index=0&id=16ea0074&lang=css"
import "./AdminDashboard.vue?vue&type=style&index=1&id=16ea0074&lang=css"
import "./AdminDashboard.vue?vue&type=style&index=2&id=16ea0074&lang=css"
import "./AdminDashboard.vue?vue&type=style&index=3&id=16ea0074&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16ea0074"]])

export default __exports__